import React from 'react'
import { Grid } from '@mui/material'
import { DataGridSettings } from '../../interfaces/DataGrid/DataGridSettings'

interface DataGridRowProps {
  settings: DataGridSettings
  bgColor?: string
}

export const DataGridRow: React.FC<DataGridRowProps> = ({
  children,
  settings,
  bgColor
}) => {
  return (
    <Grid
      container
      direction='row'
      spacing={settings.spacing}
      style={{ backgroundColor: bgColor }}
    >
      {children}
    </Grid>
  )
}
